/**
 * Canonical site-wide facts. Import these instead of re-typing them so the same
 * fact can't drift across the site (it already had — see contact.ts for emails).
 *
 * Note: the "0-to-1 …" positioning line intentionally varies by context
 * (page <title> vs schema jobTitle vs meta descriptions vs OG copy), so those
 * are not centralized here — only facts that should be byte-identical are.
 */

export const SITE_NAME = 'Arne Noori'

/** Production origin, used as the fallback when NEXT_PUBLIC_SITE_URL is unset. */
export const SITE_URL = 'https://arne.ai'

/**
 * The canonical site origin, trailing slash stripped. Use this everywhere a
 * fully-qualified URL is built (sitemaps, JSON-LD @ids, OG images) instead of
 * re-deriving `process.env.NEXT_PUBLIC_SITE_URL || 'https://arne.ai'` per file.
 */
export const getSiteUrl = () =>
  (process.env.NEXT_PUBLIC_SITE_URL || SITE_URL).replace(/\/$/, '')

/**
 * Base URL for server-side fetches of our OWN API routes. Unlike getSiteUrl()
 * (the canonical/SEO origin, always production), this resolves to an origin the
 * running server can actually reach: localhost in dev, the Vercel deployment in
 * preview, the canonical origin in prod. Using getSiteUrl() here would make dev
 * and preview self-fetch production arne.ai instead of themselves.
 */
export const getInternalBaseUrl = () => {
  // An explicit override always wins.
  if (process.env.NEXT_PUBLIC_SITE_URL) {
    return process.env.NEXT_PUBLIC_SITE_URL.replace(/\/$/, '')
  }
  // Local dev: hit our own dev server, not production.
  if (process.env.NODE_ENV !== 'production') {
    return `http://localhost:${process.env.PORT || 3000}`
  }
  // Vercel preview/prod: self-fetch the running deployment.
  if (process.env.VERCEL_URL) return `https://${process.env.VERCEL_URL}`
  return SITE_URL
}

/**
 * Current calendar year, for copyright lines and "Present" date labels.
 *
 * Must stay a function: a module-scope constant freezes at process start, so an
 * instance alive across New Year serves last year in the footer and RSS
 * copyright until it is redeployed.
 */
export function currentYear() {
  return new Date().getFullYear()
}

export const DEGREE =
  'B.S. Computer Science, Artificial Intelligence and Machine Learning Concentration'

export const SCHOOL = 'California Polytechnic State University, San Luis Obispo'
